import { render, staticRenderFns } from "./AttendanceManage.vue?vue&type=template&id=10230980"
import script from "./AttendanceManage.ts?vue&type=script&lang=ts&external"
export * from "./AttendanceManage.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports